import type { PolicyDetail } from '@/shared/api/resources';
import { formatMoney, formatRate } from '@/shared/lib/format';
import { Card, CardBody, CardHeader } from '@/shared/ui/Card';

import { enderecoDaParte, ouNaoDefinido, vigenciaDe } from '../portfolio/apolice';

/** Um dado so de leitura, com rotulo em cima. */
export function EndorsementInfo({ rotulo, valor }: { rotulo: string; valor: string }) {
  return (
    <div className="min-w-0">
      <p className="text-2xs font-semibold uppercase tracking-wide text-ink-500">
        {rotulo}
      </p>
      <p className="mt-0.5 break-words text-sm text-ink-900">{valor || '--'}</p>
    </div>
  );
}

/**
 * Secao "Detalhes da apolice" do assistente de endosso (END-052 a END-055): o que a
 * apolice diz hoje, lido da fotografia e dos campos da apolice, sem calculo.
 */
export function EndorsementPolicyDetails({ policy }: { policy: PolicyDetail }) {
  const tomador = policy.parties?.policyholder ?? null;
  const segurado = policy.parties?.insured ?? null;
  return (
    <Card>
      <CardHeader title="Detalhes da apolice" description="O que a apolice diz hoje." />
      <CardBody className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <EndorsementInfo
          rotulo="Tomador"
          valor={tomador?.legal_name ?? policy.policyholder.label}
        />
        <EndorsementInfo
          rotulo="Endereco do Tomador"
          valor={enderecoDaParte(tomador)}
        />
        <EndorsementInfo
          rotulo="Segurado"
          valor={segurado?.legal_name ?? ouNaoDefinido(null)}
        />
        <EndorsementInfo
          rotulo="Endereco do Segurado"
          valor={enderecoDaParte(segurado)}
        />
        <EndorsementInfo rotulo="Modalidade principal" valor={policy.modality.label} />
        <EndorsementInfo
          rotulo="IS principal"
          valor={formatMoney(policy.insured_amount)}
        />
        <EndorsementInfo
          rotulo="Vigencia principal"
          valor={vigenciaDe(policy.coverage_start, policy.coverage_end)}
        />
        <EndorsementInfo
          rotulo="Taxa aplicada (%)"
          valor={formatRate(policy.applied_rate_bps)}
        />
        <EndorsementInfo
          rotulo="Modalidade complementar"
          valor={ouNaoDefinido(policy.complementary_modality?.label)}
        />
        <EndorsementInfo
          rotulo="IS complementar"
          valor={
            policy.complementary_insured_amount
              ? formatMoney(policy.complementary_insured_amount)
              : ouNaoDefinido(null)
          }
        />
        <EndorsementInfo
          rotulo="Vigencia complementar"
          valor={
            policy.complementary_coverage_start
              ? vigenciaDe(
                  policy.complementary_coverage_start,
                  policy.complementary_coverage_end ?? '',
                )
              : ouNaoDefinido(null)
          }
        />
      </CardBody>
    </Card>
  );
}
